<div class="content-wrapper">
  <img
    class="bio-image"
    ngSrc="/images/russ-bio-image.webp"
    width="200"
    height="300"
    alt="Bass performance by Russ"
    priority
  />

  <!-- Russ's own "Full Website Bio", delivered 2026-09-14, verbatim apart
       from the Zoom link on the closing sentence. The home hub card carries
       the first paragraph plus his shorter EPK version; the ProfilePage
       Person description in bio-jsonld.ts restates the first sentence. -->
  <p>
    Russ Rodgers is a veteran bassist and educator with over five decades of
    professional performance and instructional experience. Throughout his
    career, Russ has studied under some of the world's foremost bass virtuosos
    and educators, including John Patitucci, Oteil Burbridge, Jimi Haslip, Janek
    Gwizdala, Anthony Wellington, Mike Pope, Trip Wamsley, Herman Burney, Corey
    Christiansen, Kevin Bales, and Ted Howe.
  </p>

  <p>
    A cornerstone of the Southeast music education scene, Russ founded the Bass
    Program at the Atlanta Institute of Music (AIM) in 1985, serving as its
    Director for eight years. He returned to AIM from 2001 to 2013 to lead
    advanced classes and private instruction, alongside directing bass programs
    at The East Cobb Music Academy and The Atlanta Bass Gallery, as well as
    teaching at Ken Stanton Music.
  </p>

  <p>
    As a live performer, Russ has toured domestically and internationally. From
    2006 to 2013, he held a seven-year residency as the house bassist at the
    Ritz-Carlton in Atlanta, performing alongside acclaimed jazz vocalist
    Theresa Hightower. In 2014, Russ relocated to the Washington, D.C. area,
    where he maintained an active performance schedule with top regional artists
    and built a global private teaching studio.
  </p>

  <p>
    Now based in Boynton Beach, Florida, Russ performs across the South Florida
    music scene and teaches students worldwide through interactive, one-on-one
    <a [routerLink]="'/'">live online Zoom sessions</a>.
  </p>

  <!-- Endorsement from Anthony Wellington — verbatim text from
       testimonials-data.ts; Wellington is one of Russ's own teachers (named in
       the opening paragraph) which makes this endorsement especially meaningful.
       Card pullquote variant: surface-backed card with a small leading glyph. -->
  <figure groovePullquote variant="card" size="md" class="bio-endorsement">
    <blockquote>
      Russell is a an amazing bass instructor! I'd recommend him to anybody.
      Incredible person too!!!
    </blockquote>
    <figcaption>Anthony Wellington</figcaption>
  </figure>

  <section class="bio-gallery" aria-labelledby="bio-gallery-heading">
    <h2 id="bio-gallery-heading" class="bio-gallery__heading">Performance</h2>
    <!-- Sequenced keyboard-navigable gallery.
         Navigation: click any tile, then use Prev/Next buttons or ←/→ keys. -->
    <app-image-gallery [images]="galleryImages" />
  </section>
</div>
